<template>
   <div class="wrapper" id="container1">
      <CRow class="mt-3">
         <CCol>
            <CButton color="info" @click="show_attendance()"
               >Show Participant</CButton
            >
            <CCard class="mt-3">
               <CButton
                  @click="cardCollapse = !cardCollapse"
                  tag="button"
                  color="link"
                  block
                  class="text-left shadow-none card-header"
               >
                  <b>Schedule's Detail </b>
                  <b-iconstack
                     class="float-right mt-1"
                     font-scale="1"
                     rotate="90"
                  >
                     <b-icon
                        v-show="!cardCollapse"
                        icon="chevron-right"
                        variant="primary"
                     ></b-icon>
                     <b-icon
                        v-show="cardCollapse"
                        class="float-right mt-1"
                        font-scale="1"
                        rotate="0"
                        icon="chevron-left"
                        variant="primary"
                     ></b-icon>
                  </b-iconstack>
               </CButton>
               <CCollapse :show="cardCollapse">
                  <CCardBody>
                     <CRow>
                        <CCol>
                           <label> Description : </label>
                           <p>
                              <b> {{ datas.data.description }} </b>
                           </p>
                           <hr />
                           <label> List Class : </label>
                           <p>
                              <b>
                                 {{ getTemplateName(datas.data.template_id) }}
                              </b>
                           </p>
                           <hr />
                           <label> Teacher : </label>
                           <p>
                              <b> {{ getTeacherName(datas.data.teacher) }} </b>
                           </p>
                           <hr />
                           <label> Participant : </label>
                           <p>
                              <b> {{ datas.data.max }} {{ "Participant" }} </b>
                           </p>
                           <hr />
                           <label> Date Schedule : </label>
                           <p>
                              <b class="font-italic">
                                 {{ datas.data.class_date }}
                              </b>
                           </p>
                           <hr />
                           <label> Date Publish : </label>
                           <p>
                              <b class="font-italic">
                                 {{ datas.data.publish_date }}
                              </b>
                           </p>
                           <hr />
                           <label> Location : </label>
                           <p>
                              <b> {{ datas.data.location }} </b>
                           </p>
                           <hr />
                           <label> Link : </label>
                           <p>
                              <b> {{ datas.data.link }} </b>
                           </p>
                        </CCol>
                     </CRow>
                  </CCardBody>
               </CCollapse>
            </CCard>
         </CCol>
      </CRow>

      <!-- {{ items }} -->
      <!-- <pre>{{ $data | json }}</pre> -->

      <alertmodal></alertmodal>
   </div>
</template>

<script>
import alertmodal from "@/views/alert/modal.vue";

import classschedule from "@/services/class_schedule";
import member from "@/services/member";
import classtemplate from "@/services/class_template";
import EventBus from "@/eventBus";

export default {
   name: "Dashboard",
   components: {
      alertmodal,
   },
   data() {
      return {
         mode: "",
         cardCollapse: true,
         datas: [],

         template_id: [],
         template_name: [],
         teacher: [],
         teacher_name: [],
      };
   },

   mounted() {
      this.loadData();

      EventBus.$on("TABLE_UPDATE", (data) => {
         if (data) {
            this.loadData();
         }
      });
   },

   methods: {
      loadData() {
         classschedule.getSchedulebyID(this.$route.query.id).then((res) => {
            this.datas = res;
            console.log(res,'ini res')
         });
         classtemplate.getTemplate().then((res) => {
            //this.classname = res.data
            for (let i = 0; i <= res.data.length - 1; i++) {
               this.template_id.push(res.data[i].id);
               this.template_name.push(res.data[i].name);
            }
            member.getMember().then((res) => {
               console.log(res, "data teacher");
               for (let i = 0; i <= res.data.member.length - 1; i++) {
                  this.teacher.push(res.data.member[i].uuid);
                  this.teacher_name.push(res.data.member[i].name);
               }
            });
         });
      },

      getTemplateName(temp) {
         return this.template_name[this.template_id.indexOf(temp)];
      },
      getTeacherName(temp) {
         return this.teacher_name[this.teacher.indexOf(temp)];
      },
      show_attendance: function() {
         let routeData = this.$router.resolve({
            path: "/schedule_detail_attendance?id="+ this.datas.data.template_id,
         });
         window.open(routeData.href, "_blank");
      },
   },
};
</script>
